import React from 'react';

import { getLocalTime } from '../../../common/utils/time/time';
import {
	didRestockBatchChange,
	getRestockBatchDraft,
	toRestockCorrectionIdString,
} from '../../../common/utils/serviceDocket/marketRestockCorrection';
import { getUserName } from '../../../common/utils/user/getUserName';

import { Text } from '../../components';
import { Card } from '../../design/components';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { createCorrectMarketRestockStyles } from './CorrectMarketRestockView.styles';

// Earlier delivered-quantity corrections of this restock, newest first.
const RestockCorrectionHistory = ({ restockCorrections, itemById, timezone }) => {
	const styles = useThemedStyles(createCorrectMarketRestockStyles);

	return (
		<>
			<Text style={styles.sectionTitle}>Revision history</Text>
			{!(restockCorrections || []).length && (
				<Text style={styles.intro}>
					No corrections have been recorded. The original restock is authoritative.
				</Text>
			)}
			{[...(restockCorrections || [])].reverse().map(correction => (
				<Card style={styles.historyCard} key={correction.revision}>
					<Text style={styles.historyTitle}>
						Revision {correction.revision}: {correction.reason}
					</Text>
					<Text style={styles.hint}>
						{correction.correctedBy ? getUserName(correction.correctedBy) : 'Unknown operator'} · {getLocalTime(timezone, correction.correctedAt).format('D MMM YYYY, h:mm a')}
					</Text>
					{(correction.changes || []).map(change => {
						const item = itemById.get(toRestockCorrectionIdString(change.pickListItem));
						const beforeBatch = getRestockBatchDraft(
							change.before?.planogramItemExpiryDatesAtPick,
							timezone,
						).label;
						const afterBatch = getRestockBatchDraft(
							change.after?.planogramItemExpiryDatesAtPick,
							timezone,
						).label;
						return (
							<Text
								style={styles.historyChange}
								key={toRestockCorrectionIdString(change.pickListItem)}
							>
								{change.productName || item?.product?.name || item?.removedProduct?.name || 'Product'}
								{change.selection ? ` · selection ${change.selection}` : ''}: {Number(change.before?.deliveredQuantity || 0)} → {Number(change.after?.deliveredQuantity || 0)}
								{didRestockBatchChange(change.before, change.after) ? ` · batch ${beforeBatch} → ${afterBatch}` : ''}
							</Text>
						);
					})}
				</Card>
			))}
		</>
	);
};

export default RestockCorrectionHistory;
